
import { toast } from "react-toastify";
import { instance } from "./https";
import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

interface ICommonService<T, I> {
  key?: string[]
  url: string;
  method?: string;
  data?: T
  params?: I
  gcTime?: number,
  invalidateTag?: string[],
  skip?: boolean

}

interface IFetch {
  method: string, url: string, pageParam?: number, params?: { [key: string]: any }, data?: any
}
interface IFetchResponse {
  data: any[]
  currentPage: number,
  nextPage: number
  totalRecords: number

}




const fetchData = ({ method, url, pageParam, params, data }: IFetch): Promise<IFetchResponse> => {
  return instance({ method, url, params: { page: pageParam, limit: 10, ...params }, data }).then(val => {
    return {
      data: val?.data?.data,
      currentPage: val?.data?.pagination?.page,
      nextPage: val?.data?.pagination?.nextPage,
      totalRecords: val?.data?.pagination?.totalDocs
    }
  }).catch(err => {
    return err
  })


}
export const useTQuery = ({ key, method = "get", url, params, gcTime = 1200 }: ICommonService<any, any>) => {
  return useQuery({
    queryKey: key || [],
    queryFn: () => instance({ method, url, params }),
    gcTime,
    retry: false,
  })
};

export const useTMutation = ({ method = "post", url, params, invalidateTag }: ICommonService<any, any>) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data?: any) => instance({ method, url, params, data }),
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: invalidateTag })
      return response
    },
    onError: (err: any) => {
      console.log({ err })
      toast.error(err?.response?.data?.message || "Something Went Wrong")

    }
  })
};

export const useTInfinitePagintaion = ({ key, method = "get", url, params, skip = false, data, gcTime = 1200 }: ICommonService<any, any>) => {
  return useInfiniteQuery({
    queryKey: key?.length > 0 ? key : [],
    queryFn: ({ pageParam }) => fetchData({ method, url, pageParam, params, data }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      return lastPage.nextPage || undefined; // undefined means no more pages
    },
    enabled: !skip,
    gcTime
  })
};

